import mime from 'mime'

/* @ngInject */
function mimeService () {
  // Define custom mime types
  mime.define({
    'application/x-coreldraw': ['cdr', 'crd']
  }, true)

  const service = {
    getType: mime.getType,
    getExtension: mime.getExtension,
    define: mime.define
  }

  return service
}

export { mimeService }
